import { render, staticRenderFns } from "./Step3-3.vue?vue&type=template&id=2982aa18&scoped=true&"
import script from "./Step3-3.vue?vue&type=script&lang=js&"
export * from "./Step3-3.vue?vue&type=script&lang=js&"
import style0 from "./Step3-3.vue?vue&type=style&index=0&id=2982aa18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2982aa18",
  null
  
)

export default component.exports